module.exports = __webpack_public_path__ + "static/assets/ba6834dd9e9cf47dc96d1c27f7655d18.gif";